// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { z } from 'zod';
export const fermentationCipAgentId = (z.string());
export const fermentationCipAgent = z.object({
    id: fermentationCipAgentId,
    fermentation_id: fermentationId,
    item_id: z.number(),
    amount_ml: z.string().nullable(),
    notes: z.string().nullable(),
    created_at: z.date().nullable(),
});
export const fermentationCipAgentInitializer = z.object({
    id: fermentationCipAgentId.optional(),
    fermentation_id: fermentationId,
    item_id: z.number(),
    amount_ml: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional().nullable(),
});
export const fermentationCipAgentMutator = z.object({
    id: fermentationCipAgentId.optional(),
    fermentation_id: fermentationId.optional(),
    item_id: z.number().optional(),
    amount_ml: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional().nullable(),
});
//# sourceMappingURL=FermentationCipAgent.js.map